import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class SaldoStockService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerSegunId(empresa_rut, sucursal_codigo, bodega_codigo, codigo, callback: Function) {
    const inputParams = {
      empresa_rut,
      sucursal_codigo,
      bodega_codigo,
      codigo
    }

    this.gqlclient.query(
      {
        query: gql`
        query ($empresa_rut: Decimal, $sucursal_codigo:Decimal, $bodega_codigo:Decimal, $codigo: Decimal) {
          saldo_stock{
            obtenerSegunId(entidad:{rut_empresa:$empresa_rut, sucursal_codigo: $sucursal_codigo, bodega_codigo:$bodega_codigo, producto_codigo:$codigo, formato_codigo:"UNID"}){
              mensajes{
                codigo
                contexto
                texto
                tipo
              }
              respuesta{
                stock_disponible
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.saldo_stock.obtenerSegunId
        callback({ mensajes, respuesta })
      }
    );
  }

  reporteCalculoPedido(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      producto_venta_cero: boolean
      dia_venta_efectivo: number
      dia_stock: number
      listaBodega: any[]
      listaFamilia: any[]
      producto_pedido_sugerido: boolean
      producto_activo: boolean
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: saldo_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_stock {
            reporteCalculoPedido(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  cant_vendida
                  monto_vendido
                  stock_actual
                  stock_sugerido
                  stock_difinitivo
                  formato_comb_cantidad
                  precio_costo
                  monto_pedido
                  total_calculo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.saldo_stock.reporteCalculoPedido
        callback({ mensajes, respuesta })
      }
    );
  }

  reporteCalculoPedidoExcel(inputParams: {
    entidad: {
      rut_empresa: number
      sucursal_codigo: number
      fecha_desde: Date
      fecha_hasta: Date
      producto_venta_cero: boolean
      dia_venta_efectivo: number
      dia_stock: number
      listaBodega: any[]
      listaFamilia: any[]
      producto_pedido_sugerido: true
      producto_activo: boolean
      retornaExcel: true
      listaSaldoStock: any[]
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: saldo_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_stock {
            reporteCalculoPedido(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rutaArchivo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.saldo_stock.reporteCalculoPedido
        callback({ mensajes, respuesta })
      }
    );
  }
  ObtenerTotalesReporte(inputParams, callback: Function) {
    //console.log('ObtenerTotalesDocumento', JSON.stringify(inputParams))
    this.gqlclient.query(
      {
        query: gql`
        query ($lista: [saldo_stockInputType]) {
          saldo_stock {
            totalCalculoPedido(lista: $lista) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                total_stock_actual
                total_pedido
                monto_pedido
                total_stock_siguiente
                total_calculo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.saldo_stock.totalCalculoPedido
        callback({ mensajes, respuesta })
      }
    );
  }

  reportePDFDetallePago(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: saldo_stockInputType) {
          saldo_stock {
            reportePDFCalculoPedido(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.saldo_stock.reportePDFCalculoPedido
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerStockProducto(inputParams, callback: Function) {
    //console.log('ObtenerTotalesDocumento', JSON.stringify(inputParams))
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: saldo_stockInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          saldo_stock {
            stockProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes{
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  bodega_codigo
                  bodega_nombre
                  producto_codigo
                  sku
                  producto_nombre
                  formato_codigo
                  formato_nombre
                  stock_disponible
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.saldo_stock.stockProducto
        callback({ mensajes, respuesta })
      }
    );
  }
}
